import React, { useContext } from 'react';
import { Link } from 'gatsby';

import { PRODUCT_LINKS } from 'consts/products';
import { navExternalWithQueryString } from 'utils/marketingSafeDomain';
import { trackEvent } from 'utils/metricsTracking';
import { EVENTS } from 'consts/metricsTrackingEvents';

import {
  StandardProductImageContainer,
  ImageTag,
  EcomProductImageContainer,
} from './ProductCardImage.style';
import { ModuleNameContext } from 'components/modules/SqueezeRedesignProducts/components/Subsection/components/ModuleNameContext';
import { type ProductCardProps } from '../ProductCard';

export const ProductCardImage = ({
  content,
}: {
  content: ProductCardProps;
}) => {
  const { image, imageTag, linkType, href, name } = content;
  const moduleName = useContext(ModuleNameContext);

  const handleECommerceProductClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    trackEvent(EVENTS.linkClicked, { productName: name, module: moduleName });
    navExternalWithQueryString(href);
  };

  const handleRxProductClick = () => {
    trackEvent(EVENTS.linkClicked, { productName: name, module: moduleName });
  };

  return linkType === PRODUCT_LINKS.eCommerce ? (
    <a href={href} onClick={handleECommerceProductClick}>
      {imageTag && <ImageTag>{imageTag}</ImageTag>}
      <EcomProductImageContainer>{image}</EcomProductImageContainer>
    </a>
  ) : (
    <Link to={href} onClick={handleRxProductClick}>
      <StandardProductImageContainer>
        {imageTag && <ImageTag>{imageTag}</ImageTag>}
        {image}
      </StandardProductImageContainer>
    </Link>
  );
};
